import { remote_collection_get_shared_by_id } from '@/state/collection/entity/remote_collection_get_shared_by_id';
import { remote_user_task_get_shared_by_generation_id } from '@/state/generation/user_task/entity/remote_user_task_get_shared_by_generation_id';
import { remote_search_get_shared_by_id } from '@/state/search/remote_search_get_shared_by_id';
import { store } from '@/state/store';
import { DTO__collection } from '@shared/dto/collection/DTO__collection';
import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';
import { DTO_RESPONSE__success } from '@shared/network/DTO_RESPONSE__success';

export const try_load_shared_collection_from_server = async (entity_id: string): Promise<DTO__collection | undefined> => {
  let out: DTO__collection | undefined = undefined;

  let result = await store.dispatch(remote_collection_get_shared_by_id(entity_id));

  if (result.payload instanceof DTO_RESPONSE__success) {
    out = store.getState().slice_collections.collections_map.get_or_assert(entity_id, { context: 'collection' });
  }

  return out;
};

export const try_load_shared_search_from_server = async (entity_id: string): Promise<DTOSearchSettings | undefined> => {
  let out: DTOSearchSettings | undefined = undefined;

  let result = await store.dispatch(remote_search_get_shared_by_id(entity_id));

  if (result.payload instanceof DTO_RESPONSE__success) {
    out = store.getState().slice_search.search_history_map.get_or_assert(entity_id, { context: 'search' });
  }

  return out;
};

export const try_load_shared_user_task_from_server_by_generation_id = async (generation_id: string): Promise<DTO__generation | undefined> => {
  let out: DTO__generation | undefined = undefined;

  let result = await store.dispatch(remote_user_task_get_shared_by_generation_id(generation_id));

  if (result.payload instanceof DTO_RESPONSE__success) {
    out = store.getState().slice_generation.generations_map.get_or_assert(generation_id, { context: 'generation' });
  }

  return out;
};
